import { CSSResultArray } from 'lit';
import style from './mc-input-date.scss';
import tokens from '@maersk-global/mds-design-tokens/implementation/core/input-date/js/design-tokens-px.css.js';
export const styles: CSSResultArray = [tokens, style];
